var stampDutyCalculator = {

    amt: 0,
    ftb: false,
    stamt: document.getElementById('stamt'),

    init: function() {
        //mortgageCalculator.setup();
        stampDutyCalculator.eventHandler();
    },
 
    setup: function() {
        var mPmt = stampDutyCalculator.calculatePayment();
        pmt.textContent = mPmt.toFixed();
    },

    eventHandler: function() {

        let propertyPrice  = document.getElementById('property-price'),
            firstTimeBuyer = document.getElementById('first-time-buyer');

        propertyPrice.addEventListener('input', function(event) {
            stampDutyCalculator.amt = propertyPrice.value;
            var amountOwed = stampDutyCalculator.calculateTax(stampDutyCalculator.amt, false, stampDutyCalculator.ftb);
            stampDutyCalculator.setAmountOwed(amountOwed);
        }, true);

        firstTimeBuyer.addEventListener('change', function(event) {
            stampDutyCalculator.ftb = this.checked;
            var amountOwed = stampDutyCalculator.calculateTax(stampDutyCalculator.amt, false, stampDutyCalculator.ftb);
            stampDutyCalculator.setAmountOwed(amountOwed);
        }, true);
    },

    calculateTax: function(price, isSecondProperty = false, isFirstTimeBuyer = false) {
        if (price <= 0) return 0;

        let tax = 0;
        let rates = [];

        // Second property surcharge (+5% on all bands)
        const surcharge = isSecondProperty ? 0.05 : 0;

        // Standard Rates (Post-April 2025 structure)
        if (isFirstTimeBuyer && !isSecondProperty) {
            // Example for FTB - 0% up to £425,000, 5% up to £625k
            if (price <= 425000) return 0;
            else if (price <= 625000) {
                return (price - 425000) * 0.05;
            }
        }

        // Standard Tiered Calculation (Modified by Surcharge)
        if (price <= 125000) {
            tax = 0;
        } else if (price <= 250000) {
            tax = (price - 125000) * (0.02 + surcharge);
        } else if (price <= 925000) {
            tax = (125000 * (0.02 + surcharge)) + ((price - 250000) * (0.05 + surcharge));
        } else if (price <= 1500000) {
            tax = (125000 * (0.02 + surcharge)) + (675000 * (0.05 + surcharge)) + ((price - 925000) * (0.10 + surcharge));
        } else {
            tax = (125000 * (0.02 + surcharge)) + (675000 * (0.05 + surcharge)) + (575000 * (0.10 + surcharge)) + ((price - 1500000) * (0.12 + surcharge));
        }

        return Math.round(tax);
    },

    setAmountOwed: function(value) {
        console.log(value);
        stamt.textContent = value.toFixed();
    }
};

let stampDuty = document.getElementById('stamp-duty-calculator');
if (typeof(stampDuty) != 'undefined' && stampDuty != null){
    window.addEventListener('load', stampDutyCalculator.init, true);
}
